import { get, post } from "../utils/httpInterceptor";

const flowBpmService = {
  getProcessDefinitions() {
    return get("/api/flow-bpm/process-definitions");
  },

  getTasks() {
    return get("/api/flow-bpm/tasks");
  },

  startProcess(processKey, variables = {}) {
    return post(`/api/flow-bpm/process-definitions/${encodeURIComponent(processKey)}/start`, {
      variables,
    });
  },

  completeTask(taskId, variables = {}) {
    return post(`/api/flow-bpm/tasks/${encodeURIComponent(taskId)}/complete`, {
      variables,
    });
  },
};

export default flowBpmService;

